import React from "react";
import { TestimonialCard } from "./TestimonialCard";
import { testimonials } from "../data/testimonials";
export function SocialProofSection() {
  return <section aria-labelledby="social-proof-heading" className="relative isolate w-full overflow-hidden bg-[#090B0D] py-20 text-[#F8F8F6] sm:py-24 lg:py-28" data-id="element-110" data-mp="2qz7vxg0qarpr">
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-1/2 -z-10 h-[82%] w-[90%] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[radial-gradient(circle,rgba(242,184,75,0.055),transparent_70%)]" data-id="element-111" data-mp="30rm1kjuxgih7" />

      <div className="mx-auto max-w-[1040px] px-4 sm:px-8 lg:px-12" data-id="element-112" data-mp="2mzfox7qzgtmi">
        <header className="text-center" data-id="element-113" data-mp="2mxmedhd91p98">
          <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-[#F2B84B] sm:text-xs" data-id="element-114" data-mp="2i0csgbp2jvq5">
            PRUEBAS SOCIALES
          </p>
          <h2 id="social-proof-heading" className="mx-auto mt-4 max-w-[760px] text-[2rem] font-bold leading-tight tracking-[-0.035em] text-[#F8F8F6] sm:text-[2.5rem] lg:text-[3.25rem]" data-id="element-115" data-mp="2bkvea5gr1yf">
            Profesionales que ya lo están usando
          </h2>
        </header>

        <div className="mx-auto mt-10 flex max-w-[900px] flex-col gap-7 sm:mt-12 sm:gap-8 lg:mt-14" data-id="element-116" data-mp="13ggcpains4x6">
          {testimonials.map(testimonial => <TestimonialCard key={testimonial.name} testimonial={testimonial} data-id="element-117" data-mp="1cfbkgr1cpn2l" />)}
        </div>
      </div>
    </section>;
}